import { Grid, Typography } from "@mui/material";
import { StyledEstablecimientos } from "../../../../styled/Prevencion";

const HeaderLabelEstablecimientoDetalle = ({ establecimiento }) => {

  return (
    <Grid container spacing={2}>
      <Grid item xs={true}>
        <StyledEstablecimientos.PaperOutlined elevation={2}>
          <StyledEstablecimientos.HeaderDiv>
            <div
              style={{
                display: "flex",
                justifyContent: "space-evenly",
              }}
            >
              <Typography>
                <strong>{establecimiento?.matrizUnica}</strong>
              </Typography>
              <Typography sx={{ paddingLeft: "30px" }}>
                <strong>{establecimiento?.nombre}</strong>
              </Typography>
            </div>
            <Typography sx={{ paddingLeft: "20px" }}>
              {establecimiento?.domicilio}
            </Typography>
          </StyledEstablecimientos.HeaderDiv>
        </StyledEstablecimientos.PaperOutlined>
      </Grid>
    </Grid>
  );
};

export default HeaderLabelEstablecimientoDetalle;
